<template>
	<div class="Hotlist">
		<!-- Hotlist -->
		<ul class="title1">
			<li class="L">推荐热榜</li>
			<li class="M"></li>
			<!-- <li class="R"><a href="" class="more3">更多</a></li> -->
		</ul>

		<ul class="zjpl_list">
			<!-- zjpl_list -->
			<li v-if="item.title" v-for="(item,index) in articlesList">
				<dl>
					<dt>
						<L>
							<a @click="jumppush('/detail/'+item.id+'?col=tuijian')" target="_blank">{{item.title}}</a>
						</L>
						<!--									<R></R>-->
					</dt>
					<!-- <dd>{{(item.summary&&item.summary.indexOf('AttachmentID=')>-1)?'&nbsp;':item.summary}}</dd> -->
				</dl>
			</li>
			
		</ul><!-- /zjpl_list -->



	</div><!-- /Hotlist -->
</template>

<script>
	export default{
		data() {
			return {
				hasPower:true,
				loadingMask:false,
				articlesList:[],
			}
		},
		mounted:function(){
			this.getArticles();
		},
		methods:{
			authcheck:function(){
				// this.hasPower=false;
				// if(!this.$cookies.get('userauth')){
				// 	this.hasPower=true;
				// }
				// else{
				// 	if(this.$cookies.get('userauth')=='1921f9e1416473a1d0f15d328e837115'){
				// 		this.hasPower=true;
				// 	}
				// 	if(this.$cookies.get('userauth').indexOf('tuijian')>-1){
				// 		this.hasPower=true;
				// 	}
				// }
			},
			jumppush:function(to){
				this.authcheck();
				if(!this.hasPower){
					alert('您未购买此栏目!');
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			getArticles:function(){
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'recommend/getRecommandArticles',
						responseType: 'json',
						params: {
							columnID:'58d7d9eb336e40e786b28718cd2a459b',
							iPage:'1',
							pageSize:'5',
						},
					})
					.then(function(response) {
						_this.articlesList=response.data.data.data.data
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			
		}
	}
</script>

<style>
</style>
